import { CLIENT_METHODS, RESOURCES, useApiMutation } from '@/data/api'

export const useSendResetPasswordEmail = (): ReturnType<typeof useApiMutation> =>
  useApiMutation(RESOURCES.SEND_RESET_PASSWORD_EMAIL, CLIENT_METHODS.POST)
